import { combineReducers } from 'redux';

import { autoCompleteLanguagesReducer } from 'features/AllowedAutoCompleteLanguagesFeature';
import { allowedEntryLanguagesReducer } from 'features/AllowedEntryLanguagesFeature';
import { allowedUiLanguageReducer } from 'features/AllowedUiLanguagesFeature';
import { cultureCodeReducer } from 'features/CultureCodeFeature';
import { currencyReducer } from 'features/CurrencyFeature';
import { languageReducer } from 'features/LanguagesFeature';
import { menuBarOrderReducer } from 'features/MenuBarOrderFeature';
import { userAllergensReducer } from 'features/PreferredAllergensFeature';
import { preferredNutrientsReducer } from 'features/PreferredNutrientsFeature';
import { quantityMethodReducer } from 'features/QuantityMethodFeature';
import { userReducer } from 'features/UserFeature';
import { userSettingsReducer } from 'features/UserSettingsFeature';
import { valueScopeReducer } from 'features/ValueScopeFeature';
import { accessoryCategoriesReducer } from 'reducers/AccessoryCategoriesReducer';
import {
	accessoryRangesReducer,
	accessoryRangesReducerArchived,
} from 'reducers/AccessoryRangesReducer';
import { allergensReducer } from 'reducers/AllergensReducer';
import { baseIngredientCategoriesReducer } from 'reducers/BaseIngredientCategoriesReducer';
import { baseIngredientListReducer } from 'reducers/BaseIngredientListReducer';
import {
	baseIngredientRangesReducer,
	baseIngredientRangesReducerArchived,
} from 'reducers/BaseIngredientRangesReducer';
import { co2LabelsReducer } from 'reducers/Co2LabelsReducer';
import { erpSourceListReducer } from 'reducers/ErpSourcesReducer';
import { ingredientCategoriesReducer } from 'reducers/IngredientCategoriesReducer';
import { ingredientListReducer } from 'reducers/IngredientListReducer';
import { ingredientRangesReducer } from 'reducers/IngredientRangesReducer';
import { menuReducer } from 'reducers/MenuReducer';
import { nutriScoreLabelsReducer } from 'reducers/NutriScoreLabelsReducer';
import { nutrientListReducer } from 'reducers/NutrientListReducer';
import { productRangesReducer } from 'reducers/ProductRangesReducer';
import { seasonsReducer } from 'reducers/SeasonReducer';
import { statusListReducer } from 'reducers/StatusListReducer';
import { tagListReducer } from 'reducers/TagListReducer';
import { unitListReducer } from 'reducers/UnitsReducer';

export const rootReducer = combineReducers({
	accessoryCategories: accessoryCategoriesReducer,
	accessoryRanges: accessoryRangesReducer,
	accessoryRangesArchived: accessoryRangesReducerArchived,
	baseIngredientRangesArchived: baseIngredientRangesReducerArchived,
	allergens: allergensReducer,
	allowedAutoCompleteLanguages: autoCompleteLanguagesReducer,
	allowedEntryLanguages: allowedEntryLanguagesReducer,
	allowedUiLanguages: allowedUiLanguageReducer,
	baseIngredientCategories: baseIngredientCategoriesReducer,
	baseIngredientList: baseIngredientListReducer,
	baseIngredientRanges: baseIngredientRangesReducer,
	co2Labels: co2LabelsReducer,
	cultureCode: cultureCodeReducer,
	currency: currencyReducer,
	erpSourceList: erpSourceListReducer,
	ingredientCategories: ingredientCategoriesReducer,
	ingredientList: ingredientListReducer,
	ingredientRanges: ingredientRangesReducer,
	languages: languageReducer,
	menu: menuReducer,
	menuBarOrder: menuBarOrderReducer,
	nutriScoreLabels: nutriScoreLabelsReducer,
	nutrientList: nutrientListReducer,
	preferredAllergens: userAllergensReducer,
	preferredNutrientIds: preferredNutrientsReducer,
	productRanges: productRangesReducer,
	quantityMethod: quantityMethodReducer,
	seasons: seasonsReducer,
	statusList: statusListReducer,
	tagList: tagListReducer,
	unitList: unitListReducer,
	user: userReducer,
	userSettings: userSettingsReducer,
	valueScope: valueScopeReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
